export const autocompleteStyles = {
  position: 'relative',
  ' .MuiAutocomplete-paper': {
    width: '100%',
  },
  '& .MuiAutocomplete-option[aria-selected="true"]': {
    background: '#F8F9FA !important',
  },
  '& .MuiAutocomplete-root .MuiAutocomplete-inputRoot': {
    rowGap: '8px',
    paddingTop: '8px',
    paddingBottom: '8px',
    '& .MuiAutocomplete-input': {
      paddingTop: 0,
      paddingBottom: 0,
    },
    '& .MuiAutocomplete-endAdornment': {
      '& .MuiAutocomplete-clearIndicator': {
        marginRight: '4px',
      },
      ' & .MuiAutocomplete-popupIndicator': {
        marginRight: 0,
      },
    },
  },
};
